export const FETCH_EDIT_BILL_ENTRIES_REPORT_REQUEST_DK = 'FETCH_EDIT_BILL_ENTRIES_REPORT_REQUEST_DK';
export const FETCH_EDIT_BILL_ENTRIES_REPORT_SUCCESS_DK = 'FETCH_EDIT_BILL_ENTRIES_REPORT_SUCCESS_DK';
export const FETCH_EDIT_BILL_ENTRIES_REPORT_FAILURE_DK = 'FETCH_EDIT_BILL_ENTRIES_REPORT_FAILURE_DK';

export const UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_REQUEST_DK = 'UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_REQUEST_DK';
export const UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_SUCCESS_DK = 'UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_SUCCESS_DK';
export const UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_FAILURE_DK = 'UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_FAILURE_DK';

export const UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_REQUEST_DK = 'UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_REQUEST_DK';
export const UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_SUCCESS_DK = 'UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_SUCCESS_DK';
export const UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_FAILURE_DK = 'UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_FAILURE_DK';

export const FETCH_EDIT_BILL_ENTRIES_FORM_REQUEST_DK = 'FETCH_EDIT_BILL_ENTRIES_FORM_REQUEST_DK';
export const FETCH_EDIT_BILL_ENTRIES_FORM_SUCCESS_DK = 'FETCH_EDIT_BILL_ENTRIES_FORM_SUCCESS_DK';
export const FETCH_EDIT_BILL_ENTRIES_FORM_FAILURE_DK = 'FETCH_EDIT_BILL_ENTRIES_FORM_FAILURE_DK';

export const FETCH_EDIT_BILL_ENTRIES_TABLE_DATA_REQUEST_DK = 'FETCH_EDIT_BILL_ENTRIES_TABLE_DATA_REQUEST_DK';
export const FETCH_EDIT_BILL_ENTRIES_TABLE_DATA_SUCCESS_DK = 'FETCH_EDIT_BILL_ENTRIES_TABLE_DATA_SUCCESS_DK';
export const FETCH_EDIT_BILL_ENTRIES_TABLE_DATA_FAILURE_DK = 'FETCH_EDIT_BILL_ENTRIES_TABLE_DATA_FAILURE_DK';

export const UPDATE_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_REQUEST_DK = 'UPDATE_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_REQUEST_DK';
export const UPDATE_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_SUCCESS_DK = 'UPDATE_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_SUCCESS_DK';
export const UPDATE_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_FAILURE_DK = 'UPDATE_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_FAILURE_DK';

export const DELETE_EDIT_BTN_UPDATE_API_REQUEST = 'DELETE_EDIT_BTN_UPDATE_API_REQUEST';
export const DELETE_EDIT_BTN_UPDATE_API_SUCCESS = 'DELETE_EDIT_BTN_UPDATE_API_SUCCESS';
export const DELETE_EDIT_BTN_UPDATE_API_FAILURE = 'DELETE_EDIT_BTN_UPDATE_API_FAILURE';

export const FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_REQUEST_DK = 'FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_REQUEST_DK';
export const FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_SUCCESS_DK = 'FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_SUCCESS_DK';
export const FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_FAILURE_DK = 'FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_FAILURE_DK';

export const CREATE_USER_FORM_EDIT_BILL_ENTRIES_DK = 'CREATE_USER_FORM_EDIT_BILL_ENTRIES_DK';

export const SET_EDIT_ENTRIES_GRID_DATA = 'SET_EDIT_ENTRIES_GRID_DATA'

export const EDIT_BILL_ENTRY_DETAIL_USERFORM_RESET = 'EDIT_BILL_ENTRY_DETAIL_USERFORM_RESET';

export const CREATE_SET_EDIT_ENTRIES_GRID_DATA = 'CREATE_SET_EDIT_ENTRIES_GRID_DATA';

export const FETCH_EDIT_BILL_ENTRY_BRN_NO_REQUEST = 'FETCH_EDIT_BILL_ENTRY_BRN_NO_REQUEST';
export const FETCH_EDIT_BILL_ENTRY_BRN_NO_SUCCESS = 'FETCH_EDIT_BILL_ENTRY_BRN_NO_SUCCESS';
export const FETCH_EDIT_BILL_ENTRY_BRN_NO_FAILURE = 'FETCH_EDIT_BILL_ENTRY_BRN_NO_FAILURE';